import {createConsoleLogApi} from "@aops-trove/fast-log";

export const log = createConsoleLogApi(); // TODO
